import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IUpdateFolderUserRequest extends IBaseRequest {
  roleName?: string;
  role?: string;
  note?: string;
  id?: string;
  userId?: string;
  folderName?: string;
  acl?: string;
  folder?: string;
  isPrimary?: string;
  contact?: string;
  userName?: string;
}

export class UpdateFolderUserRequest extends BaseRequest implements IUpdateFolderUserRequest {
  public roleName?: string;
  public role?: string;
  public note?: string;
  public id?: string;
  public userId?: string;
  public folderName?: string;
  public acl?: string;
  public folder?: string;
  public isPrimary?: string;
  public contact?: string;
  public userName?: string;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.roleName = otherOptions.roleName;
    this.role = otherOptions.role;
    this.note = otherOptions.note;
    this.id = otherOptions.id;
    this.userId = otherOptions.userId;
    this.folderName = otherOptions.folderName;
    this.acl = otherOptions.acl;
    this.folder = otherOptions.folder;
    this.isPrimary = otherOptions.isPrimary;
    this.contact = otherOptions.contact;
    this.userName = otherOptions.userName;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.roleName, 'roleName');
    parameters += this.makeNode(this.role, 'role');
    parameters += this.makeNode(this.note, 'note');
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.userId, 'userId');
    parameters += this.makeNode(this.folderName, 'folderName');
    parameters += this.makeNode(this.acl, 'acl');
    parameters += this.makeNode(this.folder, 'folder');
    parameters += this.makeNode(this.isPrimary, 'isPrimary');
    parameters += this.makeNode(this.contact, 'contact');
    parameters += this.makeNode(this.userName, 'userName');

    return super.wrapperXml('UpdateFolderUser', parameters);
  }
}
